import { render, staticRenderFns } from "./collapse-item.vue?vue&type=template&id=afe7b600&scoped=true&"
import script from "./collapse-item.vue?vue&type=script&lang=js&"
export * from "./collapse-item.vue?vue&type=script&lang=js&"
import style0 from "./collapse-item.vue?vue&type=style&index=0&id=afe7b600&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe7b600",
  null
  
)

component.options.__file = "collapse-item.vue"
export default component.exports